import React from 'react';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { getDefaultPath } from '../../helpers/pathHelper';

export default function LoginDisplay({ auth, location }) {
  if (auth.signedIn) {
    const { from } = location.state || { from: { pathname: getDefaultPath(auth.user) } };
    return <Redirect to={from} />;
  }

  if (!auth.loggingIn) {
    return (window.location.pathname = '/learning/login');
  } else {
    return <div>Logging in...</div>;
  }
}

LoginDisplay.propTypes = {
  auth: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
};
